module.exports = __webpack_public_path__ + "img/logo_esto-completo.6ee09894.png";